module.exports = __webpack_public_path__ + "static/media/mace.f71668ab.svg";